module.exports = __webpack_public_path__ + "static/cv-127e46617da755bf2e950fc4bdde8fc9.pdf";